/**
 * View component for /resource-links
 *
 * Generic resourceLink list view. Defaults to 'all' with:
 * this.props.dispatch(resourceLinkActions.fetchListIfNeeded());
 *
 * NOTE: See /product/views/ProductList.js.jsx for more examples
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';

// import actions
import * as resourceLinkActions from '../resourceLinkActions';

// import global components
import Base from "../../../global/components/BaseComponent.js.jsx";

// import resourceLink components
import ResourceLinkLayout from '../components/ResourceLinkLayout.js.jsx';
import ResourceLinkListItem from '../components/ResourceLinkListItem.js.jsx';

// import resourceLink css modules
import resourceLinkStyles from '../resourceLinkModuleStyles.css';

class ResourceLinkList extends Base {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    // fetch a list of your choice
    this.props.dispatch(resourceLinkActions.fetchListIfNeeded()); // defaults to 'all'
  }

  render() {
    const { resourceLinkStore } = this.props;

    /**
     * Retrieve the list information and the list items for the component here.
     *
     * NOTE: if the list is deeply nested and/or filtered, you'll want to handle
     * these steps within the mapStoreToProps method prior to delivering the
     * props to the component.  Othwerwise, the render() action gets convoluted
     * and potentially severely bogged down.
     */

    // get the resourceLinkList meta info here so we can reference 'isFetching'
    const resourceLinkList = resourceLinkStore.lists ? resourceLinkStore.lists.all : null;

    /**
     * use the reducer getList utility to convert the all.items array of ids
     * to the actual resourceLink objetcs
     */
    const resourceLinkListItems = resourceLinkStore.util.getList("all");

    /**
     * NOTE: isEmpty is is usefull when the component references more than one
     * resource list.
     */
    const isEmpty = !resourceLinkListItems || !resourceLinkList;

    return (
      <ResourceLinkLayout>
        <div className="flex">
          <section className="section">
            <div className="yt-container">
              <h1> Resource Link List
                <Link className="yt-btn small u-pullRight" to={'/resource-links/new'}> NEW Resource Link </Link>
              </h1>
              <hr/>
              { isEmpty ?
                (resourceLinkListItems && resourceLinkList.isFetching ? <h2>Loading...</h2> : <h2>Empty.</h2>)
                :
                <div style={{ opacity: resourceLinkList.isFetching ? 0.5 : 1 }}>
                  <ul>
                    {resourceLinkListItems.map((resourceLink, i) =>
                      <ResourceLinkListItem key={resourceLink._id + i} resourceLink={resourceLink} />
                    )}
                  </ul>
                </div>
              }
            </div>
          </section>
        </div>
      </ResourceLinkLayout>
    )
  }
}

ResourceLinkList.propTypes = {
  dispatch: PropTypes.func.isRequired
}

const mapStoreToProps = (store) => {
  /**
  * NOTE: Yote refer's to the global Redux 'state' as 'store' to keep it mentally
  * differentiated from the React component's internal state
  */
  return {
    resourceLinkStore: store.resourceLink
  }
}

export default withRouter(
  connect(
    mapStoreToProps
  )(ResourceLinkList)
);



// WEBPACK FOOTER //
// modules/resourceLink/views/ResourceLinkList.js.jsx